module.exports = {
    v: "5.6.3",
    fr: 24,
    ip: 0,
    op: 9,
    w: 60,
    h: 60,
    nm: "Menu Open",
    ddd: 0,
    assets: [],
    layers: [
        {
            ddd: 0,
            ind: 1,
            ty: 1,
            nm: "Magenta Solid 1",
            sr: 1,
            ks: {
                o: { a: 0, k: 100, ix: 11 },
                r: { a: 0, k: 0, ix: 10 },
                p: { a: 0, k: [30, 30, 0], ix: 2 },
                a: { a: 0, k: [30, 30, 0], ix: 1 },
                s: { a: 0, k: [100, 100, 100], ix: 6 },
            },
            ao: 0,
            hasMask: true,
            masksProperties: [
                {
                    inv: false,
                    mode: "f",
                    pt: {
                        a: 1,
                        k: [
                            {
                                i: { x: 0.833, y: 0.833 },
                                o: { x: 0.167, y: 0.167 },
                                t: 3,
                                s: [
                                    {
                                        i: [
                                            [0, -0.414],
                                            [0.04, -0.195],
                                            [0.076, -0.179],
                                            [0.108, -0.16],
                                            [0.136, -0.136],
                                            [0.16, -0.108],
                                            [0.179, -0.076],
                                            [0.195, -0.04],
                                            [0.207, 0],
                                            [0.195, 0.04],
                                            [0.179, 0.076],
                                            [0.16, 0.108],
                                            [0.136, 0.136],
                                            [0.108, 0.16],
                                            [0.076, 0.179],
                                            [0.04, 0.195],
                                            [0, 0.207],
                                            [-0.152, 0.359],
                                            [-0.271, 0.271],
                                            [-0.359, 0.152],
                                            [-0.414, 0],
                                            [-0.359, -0.152],
                                            [-0.271, -0.271],
                                            [-0.152, -0.359],
                                        ],
                                        o: [
                                            [0, 0.207],
                                            [-0.04, 0.195],
                                            [-0.076, 0.179],
                                            [-0.108, 0.16],
                                            [-0.136, 0.136],
                                            [-0.16, 0.108],
                                            [-0.179, 0.076],
                                            [-0.195, 0.04],
                                            [-0.207, 0],
                                            [-0.195, -0.04],
                                            [-0.179, -0.076],
                                            [-0.16, -0.108],
                                            [-0.136, -0.136],
                                            [-0.108, -0.16],
                                            [-0.076, -0.179],
                                            [-0.04, -0.195],
                                            [0, -0.414],
                                            [0.152, -0.359],
                                            [0.271, -0.271],
                                            [0.359, -0.152],
                                            [0.414, 0],
                                            [0.359, 0.152],
                                            [0.271, 0.271],
                                            [0.152, 0.359],
                                        ],
                                        v: [
                                            [33, 30],
                                            [32.939, 30.604],
                                            [32.764, 31.167],
                                            [32.487, 31.677],
                                            [32.121, 32.121],
                                            [31.677, 32.487],
                                            [31.167, 32.764],
                                            [30.604, 32.939],
                                            [30, 33],
                                            [29.396, 32.939],
                                            [28.833, 32.764],
                                            [28.323, 32.487],
                                            [27.879, 32.121],
                                            [27.513, 31.677],
                                            [27.236, 31.167],
                                            [27.061, 30.604],
                                            [27, 30],
                                            [27.236, 28.833],
                                            [27.879, 27.879],
                                            [28.833, 27.236],
                                            [30, 27],
                                            [31.167, 27.236],
                                            [32.121, 27.879],
                                            [32.764, 28.833],
                                        ],
                                        c: true,
                                    },
                                ],
                                e: [
                                    {
                                        i: [
                                            [0, 0],
                                            [-0.976, -0.976],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [-0.982, -0.853],
                                            [0, 0],
                                            [0.976, -0.976],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0.853, -0.982],
                                            [0, 0],
                                            [0.976, 0.976],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0.982, 0.853],
                                            [0, 0],
                                            [-0.976, 0.976],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [-0.853, 0.982],
                                        ],
                                        o: [
                                            [0.976, -0.976],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0.934, -0.934],
                                            [0, 0],
                                            [0.976, 0.976],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0.934, 0.934],
                                            [0, 0],
                                            [-0.976, 0.976],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [-0.934, 0.934],
                                            [0, 0],
                                            [-0.976, -0.976],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [-0.934, -0.934],
                                            [0, 0],
                                        ],
                                        v: [
                                            [19.747, 19.747],
                                            [23.283, 19.747],
                                            [23.283, 19.747],
                                            [30, 26.464],
                                            [36.718, 19.747],
                                            [40.122, 19.625],
                                            [40.253, 19.747],
                                            [40.253, 23.283],
                                            [40.253, 23.283],
                                            [33.535, 30],
                                            [40.253, 36.718],
                                            [40.375, 40.122],
                                            [40.253, 40.253],
                                            [36.718, 40.253],
                                            [36.718, 40.253],
                                            [30, 33.535],
                                            [23.283, 40.253],
                                            [19.878, 40.375],
                                            [19.747, 40.253],
                                            [19.747, 36.718],
                                            [19.747, 36.718],
                                            [26.464, 30],
                                            [19.747, 23.283],
                                            [19.625, 19.878],
                                        ],
                                        c: true,
                                    },
                                ],
                            },
                            { t: 9 },
                        ],
                        ix: 1,
                    },
                    o: { a: 0, k: 100, ix: 3 },
                    x: { a: 0, k: 0, ix: 4 },
                    nm: "Circle",
                },
            ],
            ef: [
                {
                    ty: 21,
                    nm: "Fill",
                    np: 9,
                    mn: "ADBE Fill",
                    ix: 1,
                    en: 1,
                    ef: [
                        {
                            ty: 10,
                            nm: "Fill Mask",
                            mn: "ADBE Fill-0001",
                            ix: 1,
                            v: { a: 0, k: 0, ix: 1 },
                        },
                        {
                            ty: 7,
                            nm: "All Masks",
                            mn: "ADBE Fill-0007",
                            ix: 2,
                            v: { a: 0, k: 0, ix: 2 },
                        },
                        {
                            ty: 2,
                            nm: "Color",
                            mn: "ADBE Fill-0002",
                            ix: 3,
                            v: { a: 0, k: [0, 0, 0, 1], ix: 3 },
                        },
                        {
                            ty: 7,
                            nm: "Invert",
                            mn: "ADBE Fill-0006",
                            ix: 4,
                            v: { a: 0, k: 0, ix: 4 },
                        },
                        {
                            ty: 0,
                            nm: "Horizontal Feather",
                            mn: "ADBE Fill-0003",
                            ix: 5,
                            v: { a: 0, k: 0, ix: 5 },
                        },
                        {
                            ty: 0,
                            nm: "Vertical Feather",
                            mn: "ADBE Fill-0004",
                            ix: 6,
                            v: { a: 0, k: 0, ix: 6 },
                        },
                        {
                            ty: 0,
                            nm: "Opacity",
                            mn: "ADBE Fill-0005",
                            ix: 7,
                            v: { a: 0, k: 1, ix: 7 },
                        },
                    ],
                },
            ],
            sw: 60,
            sh: 60,
            sc: "#fff",
            ip: 0,
            op: 72,
            st: 0,
            bm: 0,
        },
        {
            ddd: 0,
            ind: 2,
            ty: 4,
            nm: "Shape Layer 4",
            sr: 1,
            ks: {
                o: { a: 0, k: 100, ix: 11 },
                r: { a: 0, k: 0, ix: 10 },
                p: {
                    a: 1,
                    k: [
                        {
                            i: { x: 0.833, y: 0.833 },
                            o: { x: 0.167, y: 0.167 },
                            t: 0,
                            s: [29.875, 42.5, 0],
                            e: [29.875, 30.269, 0],
                            to: [0, -2.038, 0],
                            ti: [0, 2.038, 0],
                        },
                        { t: 3 },
                    ],
                    ix: 2,
                },
                a: { a: 0, k: [-0.125, -11.875, 0], ix: 1 },
                s: { a: 0, k: [100, 100, 100], ix: 6 },
            },
            ao: 0,
            shapes: [
                {
                    ty: "gr",
                    it: [
                        {
                            d: 1,
                            ty: "el",
                            s: { a: 0, k: [5.76, 5.76], ix: 2 },
                            p: { a: 0, k: [0, 0], ix: 3 },
                            nm: "Ellipse Path 1",
                            mn: "ADBE Vector Shape - Ellipse",
                            hd: false,
                        },
                        {
                            ty: "fl",
                            c: { a: 0, k: [0, 0, 0, 1], ix: 4 },
                            o: { a: 0, k: 100, ix: 5 },
                            r: 1,
                            bm: 0,
                            nm: "Fill 1",
                            mn: "ADBE Vector Graphic - Fill",
                            hd: false,
                        },
                        {
                            ty: "tr",
                            p: { a: 0, k: [-0.213, -12.144], ix: 2 },
                            a: { a: 0, k: [0, 0], ix: 1 },
                            s: { a: 0, k: [100, 100], ix: 3 },
                            r: { a: 0, k: 0, ix: 6 },
                            o: { a: 0, k: 100, ix: 7 },
                            sk: { a: 0, k: 0, ix: 4 },
                            sa: { a: 0, k: 0, ix: 5 },
                            nm: "Transform",
                        },
                    ],
                    nm: "Ellipse 1",
                    np: 3,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false,
                },
            ],
            ip: 0,
            op: 72,
            st: 0,
            bm: 0,
        },
        {
            ddd: 0,
            ind: 3,
            ty: 4,
            nm: "Shape Layer 2",
            sr: 1,
            ks: {
                o: { a: 0, k: 100, ix: 11 },
                r: { a: 0, k: 0, ix: 10 },
                p: {
                    a: 1,
                    k: [
                        {
                            i: { x: 0.833, y: 0.833 },
                            o: { x: 0.167, y: 0.167 },
                            t: 0,
                            s: [30, 30, 0],
                            e: [30, 42.144, 0],
                            to: [0, 2.024, 0],
                            ti: [0, -2.024, 0],
                        },
                        { t: 3 },
                    ],
                    ix: 2,
                },
                a: { a: 0, k: [0, 0, 0], ix: 1 },
                s: { a: 0, k: [100, 100, 100], ix: 6 },
            },
            ao: 0,
            shapes: [
                {
                    ty: "gr",
                    it: [
                        {
                            d: 1,
                            ty: "el",
                            s: { a: 0, k: [5.76, 5.76], ix: 2 },
                            p: { a: 0, k: [0, 0], ix: 3 },
                            nm: "Ellipse Path 1",
                            mn: "ADBE Vector Shape - Ellipse",
                            hd: false,
                        },
                        {
                            ty: "fl",
                            c: { a: 0, k: [0, 0, 0, 1], ix: 4 },
                            o: { a: 0, k: 100, ix: 5 },
                            r: 1,
                            bm: 0,
                            nm: "Fill 1",
                            mn: "ADBE Vector Graphic - Fill",
                            hd: false,
                        },
                        {
                            ty: "tr",
                            p: { a: 0, k: [-0.213, -12.144], ix: 2 },
                            a: { a: 0, k: [0, 0], ix: 1 },
                            s: { a: 0, k: [100, 100], ix: 3 },
                            r: { a: 0, k: 0, ix: 6 },
                            o: { a: 0, k: 100, ix: 7 },
                            sk: { a: 0, k: 0, ix: 4 },
                            sa: { a: 0, k: 0, ix: 5 },
                            nm: "Transform",
                        },
                    ],
                    nm: "Ellipse 1",
                    np: 3,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false,
                },
            ],
            ip: 0,
            op: 72,
            st: 0,
            bm: 0,
        },
        {
            ddd: 0,
            ind: 4,
            ty: 4,
            nm: "Menu@1x Outlines 2",
            sr: 1,
            ks: {
                o: { a: 0, k: 100, ix: 11 },
                r: { a: 0, k: 0, ix: 10 },
                p: { a: 0, k: [30, 30, 0], ix: 2 },
                a: { a: 0, k: [30, 30, 0], ix: 1 },
                s: { a: 0, k: [100, 100, 100], ix: 6 },
            },
            ao: 0,
            shapes: [
                {
                    ty: "gr",
                    it: [
                        {
                            ty: "mm",
                            mm: 1,
                            nm: "Merge Paths 1",
                            mn: "ADBE Vector Filter - Merge",
                            hd: false,
                        },
                        {
                            ty: "fl",
                            c: { a: 0, k: [0, 0, 0, 1], ix: 4 },
                            o: { a: 0, k: 100, ix: 5 },
                            r: 1,
                            bm: 0,
                            nm: "Fill 1",
                            mn: "ADBE Vector Graphic - Fill",
                            hd: false,
                        },
                        {
                            ty: "tr",
                            p: { a: 0, k: [30, 30], ix: 2 },
                            a: { a: 0, k: [0, 0], ix: 1 },
                            s: { a: 0, k: [100, 100], ix: 3 },
                            r: { a: 0, k: 0, ix: 6 },
                            o: { a: 0, k: 100, ix: 7 },
                            sk: { a: 0, k: 0, ix: 4 },
                            sa: { a: 0, k: 0, ix: 5 },
                            nm: "Transform",
                        },
                    ],
                    nm: "Group 1",
                    np: 2,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false,
                },
                {
                    ty: "gr",
                    it: [
                        {
                            ind: 0,
                            ty: "sh",
                            ix: 1,
                            ks: {
                                a: 0,
                                k: {
                                    i: [
                                        [16.56, 0],
                                        [0, 16.56],
                                        [-16.559, 0],
                                        [0, -16.559],
                                    ],
                                    o: [
                                        [-16.559, 0],
                                        [0, -16.559],
                                        [16.56, 0],
                                        [0, 16.56],
                                    ],
                                    v: [
                                        [0, 30],
                                        [-30, 0],
                                        [0, -30],
                                        [30, 0],
                                    ],
                                    c: true,
                                },
                                ix: 2,
                            },
                            nm: "Path 1",
                            mn: "ADBE Vector Shape - Group",
                            hd: false,
                        },
                        {
                            ty: "fl",
                            c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                            o: { a: 0, k: 100, ix: 5 },
                            r: 1,
                            bm: 0,
                            nm: "Fill 1",
                            mn: "ADBE Vector Graphic - Fill",
                            hd: false,
                        },
                        {
                            ty: "tr",
                            p: { a: 0, k: [30, 30], ix: 2 },
                            a: { a: 0, k: [0, 0], ix: 1 },
                            s: { a: 0, k: [100, 100], ix: 3 },
                            r: { a: 0, k: 0, ix: 6 },
                            o: { a: 0, k: 100, ix: 7 },
                            sk: { a: 0, k: 0, ix: 4 },
                            sa: { a: 0, k: 0, ix: 5 },
                            nm: "Transform",
                        },
                    ],
                    nm: "Group 2",
                    np: 2,
                    cix: 2,
                    bm: 0,
                    ix: 2,
                    mn: "ADBE Vector Group",
                    hd: false,
                },
            ],
            ip: 0,
            op: 72,
            st: 0,
            bm: 0,
        },
    ],
    markers: [],
}
